/**
 *  多维分析
 */
export default {
  dbl_multi_title: "拖拉拽分析",
  dbl_multi_number_package: "号码包",
  dbl_multi_related_number_package: "关联号码包",
  dbl_multi_success_related: "成功关联号码包",
  dbl_multi_data_source_status: "数据源",
  dbl_multi_data_source_disabled: "探索模式下不可修改数据源。如需分析，请先另存图表；如需编辑，请切换到编辑模式。",
  dbl_multi_add_data_source: "添加数据源",
  dbl_multi_number_package_info: "号码包为用户自行提取的明细分群，号码包关联是多维分析的可选项。在关联号码包的情况下，只有包含特定字段的表才有分析意义。",
  dbl_multi_filter_conditions: "过滤条件",
  dbl_multi_statistical_indicators: "统计指标",
  dbl_multi_categorical_dimensions: "分类维度",
  dbl_multi_show_dimensions: "展示维度",
  dbl_multi_x_axis: "时间X轴",
  dbl_multi_raw_column: "列",
  dbl_multi_calculate: "计算",
  dbl_multi_preview_sql: "预览SQL",
  dbl_multi_preview_sql_fail: "预览SQL失败",
  dbl_multi_operational_guide: "操作指引",
  dbl_multi_operational_one_title: "设置数据源",
  dbl_multi_operational_one_content_first: "1、点击左侧添加数据源按钮，打开数据源配置弹窗；",
  dbl_multi_operational_one_content_second: "2、点击关联号码包按钮，打开号码包选择弹窗。",
  dbl_multi_operational_two_title: "配置计算条件",
  dbl_multi_operational_two_content_tip: "简单两步完成条件配置：",
  dbl_multi_operational_two_content_first: "1、选择数据表；",
  dbl_multi_operational_two_content_second: "2、设置数据表结构，关联表字段。",
  dbl_multi_operational_three_title: '点击计算',
  dbl_multi_operational_three_content_first: '根据配置结果，拖动选项至顶部区域，完成筛选维度设置，',
  dbl_multi_operational_three_content_second: '点击计算按钮，即可生成可视化图表和数据表格。',
  dbl_multi_number_package_name: "号码包名称",
  dbl_multi_number_package_name_placeholder: "请选择号码包",
  dbl_multi_number_package_name_search: "搜索号码包",
  dbl_multi_number_package_name_info: "号码包可以为空，选择号码包后将针对对应包中的明细字段进行分析。",
  dbl_multi_number_package_sensitive_fields: "敏感字段",
	
  dbl_multi_add_field_list: "新增字段列表",
  dbl_multi_leave_info: "离开当前分析任务？",
  dbl_multi_explore_leave_info: "离开当前探索页面？",
  dbl_multi_edit: "编辑",
  dbl_multi_replace: "替换",
  dbl_multi_delete_filter_2_message: '确认删除过滤条件2？',
  dbl_multi_delete_filter_2_des: '删除将丢失 过滤条件2 的所有内容。',
  dbl_multi_clear_message: '确定清空所有选项？',
  dbl_multi_clear_des: '将丢失此前未保存的分析设置与数据逻辑。',
  dbl_multi_save_success: "{name}图表保存成功",
  dbl_multi_save_error: "图表保存失败，错误码{code}",
  dbl_multi_save_as_success: "{name}图表保存成功",
  dbl_multi_copy: "(复制)",
  dbl_multi_copy_success: "复制SQL成功",
  dbl_multi_copy_error: "复制SQL失败",
  dbl_multi_add_comparison: "添加对比项",
  dbl_multi_no_comparison: "该图表不支持对比分析",
  dbl_multi_delete_comparison: "删除对比项",
  dbl_multi_calculate_info: "计算条件已经修改，请重新点击计算按钮完成分析",
  dbl_multi_finish_calculate: "终止计算",
  dbl_multi_not_empty_filter: "过滤条件不能为空",
  dbl_multi_not_empty_metric: "统计指标不能为空",
  dbl_multi_not_empty_dimensions: "分类维度不能为空",
  dbl_multi_ikonw: '我知道了',
  dbl_multi_chart_message: '请先补充时间分类维度，再进行计算。否则无法完成{text}制作。',
  dbl_multi_chart_select_message: '未选择时间分类维度， 无法制作{text}。',
	
  dbl_multi_save_chart: "保存图表",
  dbl_multi_save_as_chart: "图表另存为",
  dbl_multi_add_analysis: "新建分析",
  dbl_multi_edit_analysis: "编辑分析",
  dbl_multi_keep_type: "保持类型",
  dbl_multi_keep_type_replace: "覆盖",
  dbl_multi_keep_type_save_as: "另存为",
  dbl_multi_replace_info: "覆盖操作将覆盖原有图表",
  dbl_multi_task_name: "图表英文名称",
  dbl_multi_task_name_placeholder: "请输入图表英文名称",
  dbl_multi_task_name_validate: "图表英文名称不能为空",
  dbl_multi_task_name_length_error: "长度不超过50字符",
  dbl_multi_task_name_same: "目录下已有相同图表英文名称，请重新命名",
  dbl_multi_task_name_cn: "图表中文名称",
  dbl_multi_task_name_cn_placeholder: "请输入图表中文名称",
  dbl_multi_task_name_cn_validate: "图表中文名称不能为空",
  dbl_multi_task_label: "图表标签",
  dbl_multi_task_label_placeholder: "请输入图表标签",
  dbl_multi_task_label_validate: "图表标签不能为空",
  dbl_multi_report_label: "添加至报表",
  dbl_multi_report_label_placeholder: "请选择报表",
  dbl_multi_task_permission: "任务权限",
  dbl_multi_task_permission_validate: "请选择任务权限",
  dbl_multi_visible_to_me_only: "仅自己可见",
  dbl_multi_visible_to_business: "业务可见",
  dbl_multi_permission_info: "请联系 @v_blljli 申请Datalab管理员权限进行相关操作",
  dbl_multi_task_custom: "自定义图表标签",
  dbl_multi_task_custom_placeholder: "请输入新标签的名称",
  dbl_multi_task_label_same: "目录下已有相同图表标签，请重新命名",
	
	
  // 新增字段列表弹窗
  dbl_multi_add_field: "新增计算字段",
  dbl_multi_edit_field: "修改计算字段",
  dbl_multi_field_setting: "字段设置",
  dbl_multi_field_existed: "字段列表",
  dbl_multi_field_setting_placeholder: "请直接输入四则运算符号来计算新指标，或使用SQL函数",
  dbl_multi_field_setting_info: "点击字段可自动添加至公式",
  dbl_multi_grammar_check: "语法检测",
  dbl_multi_filed_zh: "字段名称",
  dbl_multi_filed_zh_placeholder: "请输入字段名称",
  dbl_multi_filed_zh_valid_empty: "请输入名称",
  dbl_multi_filed_valid_length: "不能超过24个字符",
  dbl_multi_filed_en: "字段英文名称",
  dbl_multi_filed_en_placeholder: "请输入字段英文名称",
  dbl_multi_filed_en_valid_empty: "请输入英文名称",
  dbl_multi_filed_valid_used: "字段名称已使用",
  dbl_multi_filed_en_valid: "请输入合法的英文名称",
  dbl_multi_filed_type: "字段类型",
  dbl_multi_filed_type_placeholder: "请选择字段类型",
  dbl_multi_filed_type_valid: "请选择字段类型",
  dbl_multi_filed_note: "字段备注（选填）",
  dbl_multi_filed_note_placeholder: "请输入字段备注",
  dbl_multi_filed_calculation_formula: "请输入计算公式",
  dbl_multi_filed_sql_error: "SQL语法错误：",
  dbl_multi_filed_sql_success: "SQL校验成功",
  dbl_multi_filed_add_success: "新增成功",
  dbl_multi_filed_edit_success: "修改成功",
  dbl_multi_filed_edit: "编辑",
  dbl_multi_filed_delete: "删除",
  dbl_multi_delete_table: "确定删除数据表？",
  dbl_multi_delete_table_info: "删除数据表",
  dbl_multi_re_analysis: "将重新进行分析",
  dbl_multi_unnamed_chart_title: '未命名图表 ',
	
  dbl_multi_rename: '重命名',
  dbl_multi_convert_to_dimension: '转换为维度',
  dbl_multi_convert_to_metric: '转换为指标',
  dbl_multi_field_type: '字段类型',
  dbl_multi_string: '字符串',
  dbl_multi_date: '日期时间',
  dbl_multi_time: '日期时间',
  dbl_multi_number: '整数',
  dbl_multi_float: '小数',
  dbl_multi_decimal_places: '小数位数',
  dbl_multi_percent: '百分比',
  dbl_multi_dimension_value_settings: '维度值设置',
  dbl_multi_origin: '原维度值',
  dbl_multi_associated_dimension_table: '关联维度表',
  dbl_multi_system: '系统自动匹配',
  dbl_multi_customize: '自定义关联',
  dbl_multi_include_dimension_total_value: '是否含维度汇总',
  dbl_multi_include: '包含',
  dbl_multi_exclude: '不包含',
  dbl_multi_check_date_success: '转换成功',
  dbl_multi_check_date_fail: '无法转换为日期类型',
  dbl_multi_check_date_retry: '校验失败，请稍后重试',
  
  dbl_multi_exploration: '探索',
  
  dbl_multi_query_mode: '查询模式:',
  dbl_multi_aggregation: '聚合模式',
  dbl_multi_detail: '明细模式',
  dbl_multi_query_mode_info: '显示数据源的原始明细数据',
  
  dbl_multi_display_format: '展示格式: ',
  dbl_multi_unit: '数值单位',
  dbl_multi_unit_bmk: 'BMK',
  dbl_multi_unit_bmk_info: 'BMK (按BMK单位自动转换数值)',
  dbl_multi_unit_thousandsDecimals: '原始数值',
  dbl_multi_decimal: '小数位数',
  dbl_multi_not_applicable: '不适用',

  dbl_multi_database_host: '主机',
  dbl_multi_database_port: '端口号',

  dbl_multi_batch_add_table: '数据表',
  dbl_multi_batch_add_field_list: '字段列表',
  dbl_multi_batch_add_custom_field: '自定义字段',
  dbl_multi_batch_add_sensitive_disabled: '敏感字段，无法加入该区域',
  dbl_multi_batch_add_xaxis_date_only: 'X 轴仅支持日期字段',
  dbl_multi_batch_add_show_dimension_no_datetime: '展示维度不支持日期/时间字段',
  dbl_multi_batch_add_limit_disabled: '已达该图表字段数量上限',
  dbl_multi_batch_add_skipped_sensitive: '{count} 个敏感字段无法加入该区域',
  dbl_multi_batch_add_skipped_limit: '{count} 个字段因图表数量限制未添加',
  dbl_multi_batch_add_trend_dimension_date_only:
    '{count} 个非日期字段无法作为分类维度首项',
  dbl_multi_batch_add_trend_dimension_invalid: '分类维度首项须为日期字段',
};